import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { GetDocumentoPublicoResponse } from '@shared/services/responses/orquestrador-vendas/get-documento-publico.response';

/** Página PÚBLICA do documento comercial — endpoint anônimo (sem token de usuário), com rate limit (429). */
@Injectable({
  providedIn: 'root',
})
export class DocumentoPublicoService {
  private readonly apiUrl: string = environment.urlApiOrquestradorVendas + 'DocumentoPublico';

  constructor(private httpClient: HttpClient) {}

  private get options(): { headers: HttpHeaders } {
    return { headers: new HttpHeaders({ 'Content-Type': 'application/json', Accept: 'application/json' }) };
  }

  public obter(token: string): Observable<GetDocumentoPublicoResponse> {
    return this.httpClient
      .get<GetDocumentoPublicoResponse>(`${this.apiUrl}/${token}`, this.options)
      .pipe(catchError(this.handleError));
  }

  // Sem o handleError global (que redireciona no 401). Preserva o status HTTP: o componente trata o 429.
  private handleError(error: HttpErrorResponse): Observable<never> {
    return throwError(() => error);
  }
}
